import { AppTheme } from "../../theme/App.theme";
// Sidebar config for navigation menu styling
export const SIDEBAR_MENU_CONFIG = {
  sidebar_width: 276,
  nav_icon: {
    default: "#222",
    active: AppTheme.PRIMARY_COLOR,
    size: 24,
    minWidth: 36,
  },
  nav_item: {
    fontSize: "14px",
    fontWeight: 500,
    fontWeightActive: 600,
    borderRadius: '12px',
    highlightBg: AppTheme.PRIMARY_LIGHT,
    highlightColor: AppTheme.PRIMARY_COLOR,
    nestedEleColor: AppTheme.NESTED_SIDEBAR_ELE_COLOR,
    hoverBg: AppTheme.SIDEBAR_HOVER,
    marginBottom: 1,
    paddingLeftNested: 2,
  },
  sidebar_box: {
    maxHeight: "85vh",
    overflowY: "auto",
    bgcolor: "#fff",
    p: 1,
    display: "flex",
    flexDirection: "column",
  },
  sidebar_list: {
    width: '100%'
  }
};